import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiscussionsComponent } from '@app/shared/components/discussions/discussions.component';

import { ProductsService } from '@vestiaire/api-sdk-angular';
import { MessageComponent } from './message/message.component';
import { DiscussionsModalComponent } from './discussions-modal/discussions-modal.component';
import { FormsModule } from '@angular/forms';
import { DiscussionsFormComponent } from '@app/shared/components/discussions/discussions-form/discussions-form.component';
import { WindowRefService } from '@app/shared/services/windowRef/window-ref.service';
import { MatDialogModule } from '@angular/material/dialog';
import { DiscussionsService } from '@app/shared/components/discussions/service/discussions.service';
import { SvgModule } from '@app/shared/components/svg/svg.module';
import { LikeModule } from '@app/shared/components/like/like.module';
import { ImagesModule } from '@app/shared/components/images/images.module';
import { MmaoModule } from '@app/shared/components/mmao/mmao.module';
import { LoaderModule } from '../loader/loader.module';

@NgModule({
  imports: [CommonModule, FormsModule, MatDialogModule, SvgModule, LikeModule, ImagesModule, MmaoModule, LoaderModule],
  exports: [DiscussionsComponent],
  declarations: [DiscussionsComponent, MessageComponent, DiscussionsModalComponent, DiscussionsFormComponent],
  providers: [ProductsService, WindowRefService, DiscussionsService],
  entryComponents: [DiscussionsModalComponent]
})
export class DiscussionsModule {}
